module.exports = __webpack_public_path__ + "static/media/create-video.47363498.svg";